import { useTranslation } from 'react-i18next';
import CommonBanner from '../component/Common/CommonBanner'
import FlightCalendarArea from '../component/FlightCalendar'

const FlightCalendar = () => {
  const { t } = useTranslation();
  return (
    <>
      <CommonBanner heading={t("flexibleDates")} pagination="Flight calendar" />
      <FlightCalendarArea />
    </>
  )
}

export default FlightCalendar
